import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  title = ''
  titleUrl = ''
  title1 = ''
  title1Url = ''
  source = ''
  sources = []
  destination = ''
  destinations = []
  conversionRate = 0
  fees = 0
  convertedAmount: number
  sourceAmount : number = 0 
  destinationsToBeShown = []
  carouselIndex = 0
  i=0
  destination_carousel_length=3

  constructor(private common : CommonService, private authService : AuthService, private router:Router) { }

  ngOnInit(): void {
    if(this.authService.isAuthenticated()){
      this.router.navigateByUrl('/dashboard')
    }
    setTimeout(() => {
      if(window.innerWidth<768){
        this.destination_carousel_length = 1
      }
      this.getAllSources()
      this.getAllDestinations()
      this.getExchangeRate(this.source, this.destination)
      this.carouselIndex = 0
    }, 500);
    
  }

  getAllSources(){
    this.common.showLoader()
    this.common.getAllSources().subscribe((res:any)=>{
      this.sources = res.filter(source => source.state)
      this.selectSource(res[0].name, res[0].image.url)
      this.common.hideLoader()
    },(err : any) => {
      console.log(err)
      this.common.hideLoader()
    })
  }

  getAllDestinations(){
    this.common.showLoader()
    this.common.getAllDestinations().subscribe((res:any)=>{
      this.destinations = res
      this.destinationsToBeShown = this.destinations.slice(+this.i, +this.i+this.destination_carousel_length)
      // this.destinationsToBeShown = this.destinationsToBeShown.splice(0,3)
      this.selectDestination(res[3].name, res[3].image.url)
      this.common.hideLoader()
    },(err : any) => {
      console.log(err)
      this.common.hideLoader()
    })
  }

  selectSource(currency, url){
    this.title = currency
    this.titleUrl = url
    this.source = currency
    this.getFees()
    this.getExchangeRate(this.source, this.destination)
  }

  selectDestination(currency, url){
    this.title1 = currency
    this.title1Url = url
    this.destination = currency
    this.getFees()
    this.getExchangeRate(this.source, this.destination)
  }

  getFees(){
    console.log(this.source, this.destination)
    this.common.getFees(this.source, this.destination).subscribe((res:any)=>{
      this.fees = res[0]?.amount
    }, (err:any)=>{
      console.log(err)
    })
  }

  getExchangeRate(source, destination){

    if(source && destination){
      this.common.getExchangeRate(source, destination).subscribe((res:any)=>{
        this.conversionRate = res[0].rate
        this.changeDestinationAmount()
      }, (err:any)=>{
        console.log(err)
      })
    }
    
  }

  changeDestinationAmount(){
    this.convertedAmount = this.sourceAmount * this.conversionRate
  }

  next(){
    
    if(this.i+this.destination_carousel_length<this.destinations.length){
      this.i+=this.destination_carousel_length
      this.destinationsToBeShown = this.destinations.slice(this.i, this.i+this.destination_carousel_length)
    }
  }

  prev(){
    if(this.i-this.destination_carousel_length>=0){
      this.i-=this.destination_carousel_length
      this.destinationsToBeShown = this.destinations.slice(this.i, this.i+this.destination_carousel_length)
    }
  }
}
